import script from "./AdminUserMemo.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUserMemo.vue?vue&type=script&setup=true&lang=js"

import "./AdminUserMemo.vue?vue&type=style&index=0&id=723bad89&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/gs-webex-sys/gs-webex-sys/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-723bad89"]])

export default __exports__